import { ActivityParent, Table } from "./activity.styles";
import React from "react";





const Activity = () => {

    return (

        <ActivityParent>
           
            <Table>
            
                <table>
                <h1>Activity log</h1>
                    <tr>
                        
                        <td>Your vetting request has been sent to ifedola@gmail.com</td>
                        <td>8:00am</td>
                        <td>May 11,2023</td>
                    </tr>
                    <tr>
                        <td>Your vetting request has been sent to ifedola@gmail.com</td>
                        <td>8:00am</td>
                        <td>May 11,2023</td>
                    </tr>
                    <tr>
                        <td>Your vetting request has been sent to ifedola@gmail.com</td>
                        <td>8:00am</td>
                        <td>May 11,2023</td>
                    </tr>
                    <tr>
                        <td>Your vetting request has been sent to ifedola@gmail.com</td>
                        <td>8:00am</td>
                        <td>May 11,2023</td>
                    </tr>

                </table>

            </Table>





        </ActivityParent>






    )


}

export default Activity;